export const JOB_POSTING_PERMISSION_CODES = {
    WEB_RECRUITMENT_JOB_POSTING_LIST: 'WEB_RECRUITMENT_JOB_POSTING_LIST',
    WEB_RECRUITMENT_JOB_POSTING_DETAIL: 'WEB_RECRUITMENT_JOB_POSTING_DETAIL',
    WEB_RECRUITMENT_JOB_POSTING_ADD: 'WEB_RECRUITMENT_JOB_POSTING_ADD',
    WEB_RECRUITMENT_JOB_POSTING_EDIT: 'WEB_RECRUITMENT_JOB_POSTING_EDIT',
    WEB_RECRUITMENT_JOB_POSTING_DELETE: 'WEB_RECRUITMENT_JOB_POSTING_DELETE',
    WEB_RECRUITMENT_JOB_POSTING_IMPORT: 'WEB_RECRUITMENT_JOB_POSTING_IMPORT',
    WEB_RECRUITMENT_JOB_POSTING_EXPORT: 'WEB_RECRUITMENT_JOB_POSTING_EXPORT',
} as const;

